import { useState, type FormEvent } from 'react';

import { Button, Input } from '../ui';

const CODE_LENGTH = 6;

interface MfaCodeFormProps {
  inputId: string;
  copy: {
    label: string;
    help: string;
    submit: string;
    submitting: string;
    back: string;
  };
  isSubmitting: boolean;
  onSubmit: (code: string) => void;
  onBack: () => void;
  onDirty: () => void;
}

export const MfaCodeForm = ({
  inputId,
  copy,
  isSubmitting,
  onSubmit,
  onBack,
  onDirty,
}: MfaCodeFormProps) => {
  const [code, setCode] = useState('');

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    onSubmit(code.trim());
  };

  return (
    <form className="space-y-6" onSubmit={handleSubmit}>
      <div>
        <label htmlFor={inputId} className="mb-2 block text-sm font-medium text-brand-blue">
          {copy.label}
        </label>
        <Input
          id={inputId}
          name={inputId}
          type="text"
          inputMode="numeric"
          autoComplete="one-time-code"
          required
          maxLength={CODE_LENGTH}
          className="text-center text-2xl tracking-widest"
          placeholder="000000"
          value={code}
          onChange={(event) => {
            setCode(event.target.value.replace(/\D/g, ''));
            onDirty();
          }}
        />
        <p className="mt-2 text-xs text-brand-blue/60">{copy.help}</p>
      </div>

      <div className="flex flex-col gap-3 sm:flex-row">
        <Button
          type="button"
          variant="outline"
          onClick={onBack}
          disabled={isSubmitting}
          className="w-full sm:w-auto"
        >
          {copy.back}
        </Button>
        <Button
          type="submit"
          loading={isSubmitting}
          disabled={code.trim().length < CODE_LENGTH}
          variant="primary"
          className="w-full sm:flex-1"
        >
          {isSubmitting ? copy.submitting : copy.submit}
        </Button>
      </div>
    </form>
  );
};
